if (!customElements.get('collection-sort')) {
	customElements.define(
		'collection-sort',
		class CollectionSort extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.form = this.querySelector('form');
				this.filters = document.querySelector('collection-filters');

				this.bindEvents();
			}

			bindEvents() {
				if (this.form && this.filters) {
					this.form.addEventListener('change', () => {
						this.filters.onChange(new FormData(this.form));
					});
				}
			}
		}
	);
}
